<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Graduation" class="d-icon d-icon--graduation" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.374 2.135a1.499 1.499 0 0 1 1.244 0l4.276 1.95a1 1 0 0 1 .605.955V8.5a.5.5 0 1 1-1 0V6.102l-.999.454v1.56c0 .673-.56 1.151-1.17 1.432C7.688 9.846 6.849 10 6 10c-.848 0-1.687-.154-2.33-.452-.61-.28-1.17-.759-1.17-1.433V6.554l-1.406-.642a1 1 0 0 1 0-1.828l4.28-1.949ZM3.5 7.01v1.105c0 .061.072.287.588.525C4.57 8.863 5.257 9 6 9c.743 0 1.43-.137 1.912-.36.516-.238.588-.464.588-.525V7.01l-1.882.855a1.5 1.5 0 0 1-1.245 0L3.5 7.01Zm7-2.007L6.203 6.955a.503.503 0 0 1-.415 0L1.507 5.001 1.5 4.998l4.288-1.953a.5.5 0 0 1 .415 0l4.282 1.952.014.006Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconGraduation',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
